import { ActivatedRouteSnapshot } from '@angular/router'

export function getCreateUpdatePermission (activatedRoute: ActivatedRouteSnapshot): string {
  return activatedRoute.params.id === 'new' ? 'create' : 'get'
}

export function getScheduleUpdateExamPermission (activatedRoute: ActivatedRouteSnapshot): string {
  return activatedRoute.params.id === 'new' ? 'schedule-exam' : 'get'
}

export function getGradeCreateUpdatePermission (activatedRoute: ActivatedRouteSnapshot): string {
  return activatedRoute.params.id === 'new' ? 'add-grade' : 'get-grade'
}

// @ts-expect-error ts-migrate(6133) FIXME: 'activatedRoute' is declared but its value is neve... Remove this comment to see the full error message
export function usersSearchResource (activatedRoute: ActivatedRouteSnapshot, tenant: any): string {
  return tenant ? 'tenant' : 'user'
}

// @ts-expect-error ts-migrate(6133) FIXME: 'activatedRoute' is declared but its value is neve... Remove this comment to see the full error message
export function usersSearchPermission (activatedRoute: ActivatedRouteSnapshot, tenant: any): string {
  return tenant ? 'get-members' : 'search'
}

// @ts-expect-error ts-migrate(6133) FIXME: 'activatedRoute' is declared but its value is neve... Remove this comment to see the full error message
export function userDetailResource (activatedRoute: ActivatedRouteSnapshot, tenant: any): string {
  return tenant ? 'tenant' : 'user'
}

export function userDetailPermission (activatedRoute: ActivatedRouteSnapshot, tenant: any): string {
  if (!tenant) {
    return activatedRoute.params.id === 'new' ? 'create' : 'get'
  }
  return activatedRoute.params.id === 'new' ? 'add-member' : 'get-member'
}

export const PAGES = {
  profile: {
    path: 'profile',
    data: {
      icon: 'lock',
      title: 'PROFILE.TITLE'
    }
  },
  home: {
    path: 'home',
    sidebar: true,
    data: {
      icon: 'dashboard',
      title: 'HOME.TITLE'
    }
  },
  tenant: {
    path: 'tenants/:id',
    data: {
      icon: 'shield',
      title: 'TENANT.DETAIL_TITLE',
      resource: 'tenant',
      permission: getCreateUpdatePermission
    }
  },
  forcePassword: {
    path: 'users/:id/force-password',
    data: {
      icon: 'key',
      title: 'USER.FORCE_PASSWORD',
      resource: 'tenant',
      permission: 'force-member-password'
    }
  },

  // custom per app
  topics: {
    path: 'topics',
    sidebar: true,
    data: {
      icon: 'newspaper-o',
      title: 'TOPIC.SEARCH_TITLE',
      resource: 'topic',
      permission: 'search',
      requiresTenant: true
    }
  },
  replies: {
    path: 'replies',
    sidebar: true,
    data: {
      icon: 'comments-o',
      title: 'Respuestas',
      resource: 'topic',
      permission: 'search',
      requiresTenant: true
    }
  },
  topic: {
    path: 'topics/:id',
    data: {
      icon: 'newspaper-o',
      title: 'TOPIC.DETAIL_TITLE',
      resource: 'topic',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  albums: {
    path: 'albums',
    sidebar: true,
    data: {
      icon: 'picture-o',
      title: 'ALBUM.SEARCH_TITLE',
      resource: 'topic',
      permission: 'search',
      requiresTenant: true
    }
  },
  album: {
    path: 'albums/:id',
    data: {
      icon: 'picture-o',
      title: 'ALBUM.DETAIL_TITLE',
      resource: 'topic',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  feed: {
    path: 'feed/:id',
    data: {
      icon: 'rss',
      title: 'TOPIC.SEARCH_TITLE',
      resource: 'topic',
      permission: 'search',
      requiresTenant: true
    }
  },
  attendance: {
    path: 'attendance/:stageId/:gradeId/:divisionId',
    data: {
      icon: 'check-square-o',
      title: 'DIVISION.ATTENDANCE',
      resource: 'division',
      permission: 'attendance',
      requiresTenant: true
    }
  },
  promotion: {
    path: 'divisions/:id/promote',
    data: {
      icon: 'level-up',
      title: 'PROMOTION.PROMOTE',
      resource: 'division',
      permission: 'promote',
      requiresTenant: true
    }
  },
  exam: {
    path: 'divisions/:divisionId/exams/:id',
    data: {
      icon: 'file-text-o',
      title: 'TOPIC_TYPES.exam',
      resource: 'division',
      permission: getScheduleUpdateExamPermission,
      requiresTenant: true
    }
  },
  rating: {
    path: 'divisions/:divisionId/ratings/:id',
    data: {
      icon: 'file-text-o',
      title: 'TOPIC_TYPES.rating',
      resource: 'division',
      permission: getScheduleUpdateExamPermission,
      requiresTenant: true
    }
  },

  people: {
    header: true,
    sidebar: true,
    data: {
      title: 'MENUASIDE.PEOPLE'
    }
  },
  students: {
    path: 'students',
    sidebar: true,
    data: {
      icon: 'universal-access',
      title: 'STUDENT.SEARCH_TITLE',
      resource: 'student',
      permission: 'search',
      requiresTenant: true
    }
  },
  student: {
    path: 'students/:id',
    data: {
      icon: 'universal-access',
      title: 'STUDENT.DETAIL_TITLE',
      resource: 'student',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  guardians: {
    path: 'guardians',
    sidebar: true,
    data: {
      icon: 'user-circle-o',
      title: 'GUARDIAN.SEARCH_TITLE',
      resource: 'guardian',
      permission: 'search',
      requiresTenant: true
    }
  },
  guardian: {
    path: 'guardians/:id',
    data: {
      icon: 'user-circle-o',
      title: 'GUARDIAN.DETAIL_TITLE',
      resource: 'guardian',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  teachers: {
    path: 'teachers',
    sidebar: true,
    data: {
      icon: 'id-card-o',
      title: 'TEACHER.SEARCH_TITLE',
      resource: 'teacher',
      permission: 'search',
      requiresTenant: true
    }
  },
  teacher: {
    path: 'teachers/:id',
    data: {
      icon: 'id-card-o',
      title: 'TEACHER.DETAIL_TITLE',
      resource: 'teacher',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  employees: {
    path: 'employees',
    sidebar: true,
    data: {
      icon: 'id-badge',
      title: 'EMPLOYEE.SEARCH_TITLE',
      resource: 'employee',
      permission: 'search',
      requiresTenant: true
    }
  },
  employee: {
    path: 'employees/:id',
    data: {
      icon: 'id-badge',
      title: 'EMPLOYEE.DETAIL_TITLE',
      resource: 'employee',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  supervisors: {
    path: 'supervisors',
    sidebar: true,
    data: {
      icon: 'street-view',
      title: 'SUPERVISOR.SEARCH_TITLE',
      resource: 'supervisor',
      permission: 'search',
      requiresTenant: true
    }
  },
  supervisor: {
    path: 'supervisors/:id',
    data: {
      icon: 'street-view',
      title: 'SUPERVISOR.DETAIL_TITLE',
      resource: 'supervisor',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  organization: {
    header: true,
    sidebar: true,
    data: {
      title: 'MENUASIDE.ORGANIZATION'
    }
  },
  divisions: {
    path: 'divisions',
    sidebar: true,
    data: {
      icon: 'th-large',
      title: 'DIVISION.SEARCH_TITLE',
      resource: 'division',
      permission: 'search',
      requiresTenant: true
    }
  },
  division: {
    path: 'divisions/:id',
    data: {
      icon: 'th-large',
      title: 'DIVISION.DETAIL_TITLE',
      resource: 'division',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  reportCard: {
    path: 'report-cards/:id',
    data: {
      icon: 'table',
      title: 'REPORT_CARDS.DETAIL_TITLE',
      resource: 'report-card',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  subjectReportCards: {
    path: 'divisions/:divisionId/courses/:courseId/reportCards',
    data: {
      icon: 'table',
      title: 'REPORT_CARDS.DETAIL_TITLE',
      resource: 'report-card',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  grades: {
    path: 'grades',
    sidebar: true,
    data: {
      icon: 'sitemap',
      title: 'GRADE.SEARCH_TITLE',
      resource: 'stage',
      permission: 'search',
      requiresTenant: true
    }
  },
  grade: {
    path: 'grades/:id',
    data: {
      icon: 'sitemap',
      title: 'GRADE.DETAIL_TITLE',
      resource: 'stage',
      permission: getGradeCreateUpdatePermission,
      requiresTenant: true
    }
  },
  subjects: {
    path: 'subjects',
    sidebar: true,
    data: {
      icon: 'book',
      title: 'SUBJECT.SEARCH_TITLE',
      resource: 'subject',
      permission: 'search',
      requiresTenant: true
    }
  },
  subject: {
    path: 'subjects/:id',
    data: {
      icon: 'book',
      title: 'SUBJECT.DETAIL_TITLE',
      resource: 'subject',
      permission: getCreateUpdatePermission,
      requiresTenant: true
    }
  },
  // terms: {
  //   path: 'terms',
  //   sidebar: true,
  //   data: {
  //     icon: 'calendar-check-o',
  //     title: 'TERM.SEARCH_TITLE',
  //     resource: 'term',
  //     permission: 'search',
  //     requiresTenant: true
  //   }
  // },
  // term: {
  //   path: 'terms/:id',
  //   data: {
  //     icon: 'calendar-check-o',
  //     title: 'TERM.DETAIL_TITLE',
  //     resource: 'term',
  //     permission: getCreateUpdatePermission,
  //     requiresTenant: true
  //   }
  // },

  others: {
    header: true,
    sidebar: false,
    data: {
      title: 'MENUASIDE.OTHERS'
    }
  },
  batchJobs: {
    path: 'batch-jobs',
    sidebar: false,
    data: {
      icon: 'tasks',
      title: 'BATCH_JOB.SEARCH_TITLE',
      resource: 'batch-job',
      permission: 'search',
      requiresTenant: true
    }
  },
  batchJob: {
    path: 'batch-jobs/:id',
    data: {
      icon: 'tasks',
      title: 'BATCH_JOB.DETAIL_TITLE',
      resource: 'batch-job',
      permission: 'get',
      requiresTenant: true
    }
  },
  reports: {
    path: 'reports',
    sidebar: false,
    data: {
      icon: 'table',
      title: 'REPORTS.TITLE',
      resource: 'reports',
      permission: 'request',
      requiresTenant: true,
    }
  },
  invoices: {
    path: 'invoices',
    sidebar: true,
    data: {
      icon: 'dollar',
      title: 'Facturación',
      resource: 'invoices',
      permission: 'search',
      requiresTenant: true,
      isInvoice: true
    }
  },
  documents: {
    path: 'documents',
    sidebar: true,
    data: {
      icon: 'file-text-o',
      title: 'Documentos',
      requiresTenant: true,
      isDocument: true
    }
  },
}
